import { css } from '@emotion/css'
import { ToggleButton } from 'components/ToggleButton/ToggleButton'
import { translate } from 'i18n/i18n'
import type { TEvapotranspirationValueToShow } from 'stores/detailsPanelStore/detailsPanelStore'
import { detailsPanelStore } from 'stores/detailsPanelStore/detailsPanelStore'

export const EvapotranspirationToggle = () => {
  const evapotranspirationValueToShow = detailsPanelStore.getState().evapotranspirationValueToShow

  return (
    <ToggleButton
      buttonProps={{ size: 'xs', className: css({ fontSize: 13 }) }}
      data={[
        { label: translate.phrases.unitSymbols('ETc'), value: 'ETC' },
        { label: translate.phrases.unitSymbols('ETo'), value: 'ETO' },
      ]}
      onChange={(newValue) =>
        detailsPanelStore.setState((s) => ({
          ...s,
          evapotranspirationValueToShow: newValue as TEvapotranspirationValueToShow,
        }))
      }
      value={evapotranspirationValueToShow}
    />
  )
}
